import { render, staticRenderFns } from "./attendanceStatistics.vue?vue&type=template&id=d2d65bc2&scoped=true&"
import script from "./attendanceStatistics.vue?vue&type=script&lang=js&"
export * from "./attendanceStatistics.vue?vue&type=script&lang=js&"
import style0 from "./attendanceStatistics.vue?vue&type=style&index=0&id=d2d65bc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2d65bc2",
  null
  
)

export default component.exports